import { useState } from "react";
import {
  DropdownArrow,
  DropdownContainer,
  DropdownItem,
  DropdownMenu,
  PrimaryLabel,
  SecondaryLabel,
} from "./styles";
import { HeadingText } from "../../../underwriterDashboard/styles";
import styled from "styled-components";

const DropdownContent = styled.div`
  background-color: ${(props) => (props.disabled ? "#ece9f1" : "white")};
  padding: 15px 15px 5px 15px;
  border-radius: 6px;
  border: 1px solid #ece9f1;
  display: inline-block;
  transition: width 0.3s ease-in-out;
  min-width: max-content;
  width: auto;
  overflow: hidden;
`;

export const SubsidiaryDropDown = ({
  children,
  options,
  onSelect,
  disabled,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    if (onSelect) {
      onSelect(option);
    }
    setIsOpen(false);
  };

  return (
    <DropdownContainer onClick={handleToggle}>
      <DropdownContent disabled={disabled}>
        <HeadingText {...props}>
          {children}
          {!disabled && <DropdownArrow isOpen={isOpen}>▼</DropdownArrow>}
        </HeadingText>
      </DropdownContent>

      {!disabled && isOpen && options && options.length > 0 && (
        <DropdownMenu>
          {[...options]
            .sort((a, b) => a.primaryLabel.localeCompare(b.primaryLabel))
            .map((option, index) => (
              <DropdownItem
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(option);
                }}
              >
                <PrimaryLabel>{option.primaryLabel}</PrimaryLabel>
                <SecondaryLabel>{option.secondaryLabel}</SecondaryLabel>
              </DropdownItem>
            ))}
        </DropdownMenu>
      )}
    </DropdownContainer>
  );
};
